import { Loader2 } from 'lucide-react';
import { cn } from '../lib/cn.js';

export interface SpinnerProps {
  className?: string;
  /** Libellé lu par les lecteurs d'écran ; omis si le contexte l'annonce déjà. */
  label?: string;
}

export function Spinner({ className, label }: SpinnerProps) {
  return (
    <>
      <Loader2 className={cn('ico spinner', className)} aria-hidden="true" />
      {label ? <span className="sr-only">{label}</span> : null}
    </>
  );
}
